import { render, staticRenderFns } from "./posts-table.vue?vue&type=template&id=9b8aa796&"
import script from "./posts-table.vue?vue&type=script&lang=js&"
export * from "./posts-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports